import { createRoot } from 'react-dom/client';

import App from '@/App';
import { initSentry } from '@/utils/matrix';

const CHUNK_RELOAD_KEY = 'chunk-reload-attempted';

window.addEventListener('vite:preloadError', (event) => {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
  event.preventDefault();
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
});

if (window.location.origin === ORIGIN_URL) {
  initSentry({
    dsn: MATRIX_DSN,
    origin: ORIGIN_URL,
    release: BUILD_VERSION
  });
}

const app = document.getElementById('app');
if (app) {
  const root = createRoot(app);
  root.render(<App />);
}
